export async function unblockUser(userId, reason, token) {
    try {
        const res = await fetch(`https://boxmealadminapinew.azurewebsites.net/api/auth/unblock-user`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            },
            body: JSON.stringify({ userId, reason })
        });

        const data = await res.json();

        if (res.ok) {
            return { success: true, message: data.message };
        } else {
            const errors = data.errors || [data.message] || ["Unknown error"];
            return { success: false, errors: Array.isArray(errors) ? errors : [errors] };
        }
    } catch (error) {
        return { success: false, errors: [error.message || "Unknown error"] };
    }
}

